<template>
    <!--Business license main container-->

    <div class="admin-bussines-license">
        <!--Heading-->
        <div class="heading-container">
            <div class="heading">
                <h3>{{ $t("businessLicense.businessLicense") }}</h3>
            </div>

            <div class="select-team-container" v-if="listing">
                <div v-if="adminDetails.group_owner == 1 && adminDetails.group_active == 1" class="select-team-wrap">
                    <label class="stylist-label" for="stylist-select"
                        :class="generalOptions.app_id === 5 ? 'loctician' : ''">Select
                        {{
                            generalOptions.app_id === 1
                                ? "Stylist"
                                : generalOptions.app_id === 2
                                    ? "Barber"
                                    : generalOptions.app_id === 5
                                        ? "Loctician"
                                        : ""
                        }}</label>
                    <select id="stylist-select" class="selectInput selectInputSmall" v-model="for_stylist_id"
                        v-on:change="onStylistChange">
                        <option v-for="(member, index) in groupMembers" v-bind:key="index" v-bind:value="member.user.id"
                            v-bind:disabled="member.active != 1">
                            {{ member.user.first_name }} {{ member.user.last_name }}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <div v-if="!firstLoad">

            <!--Page content-->
            <div class="business-license-content" v-if="listing">
                <div class="add-new-license-wrap">
                    <button v-if="listing" @click="clearLicense" class="primary-btn extra-small">
                        <i class="fa fa-plus"></i> {{ $t("businessLicense.addNewLicense") }}
                    </button>
                </div>
                <template v-if="licenses.length">
                    <div class="cards-body-wrap section-wrap">
                        <div v-for="license in licenses" :key="license.id">
                            <div class="card-license highlighted-box section-wrap">
                                <div class="card-content">
                                    <h5 class="card-title">{{ license.first_name }} {{ license.last_name }}</h5>
                                    <h6 class="card-subtitle">#{{ license.number }}</h6>
                                    <p class="card-text" v-html="license.information"></p>
                                </div>
                                <div class="license-btns-wrapper">
                                    <div class="license-btns">
                                        <a href="#" @click="editLicense(license.id)" class="primary-btn extra-small">
                                            {{ $t("businessLicense.view") }}</a>
                                        <a href="#" @click="deleteLicense(license.id)" class="secondary-btn small">{{
                                            $t("businessLicense.delete")
                                        }}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="section-wrap no-license">
                        <h5>{{ $t("businessLicense.noLicensesForThisStylist") }}</h5>
                    </div>
                </template>
            </div>
            <!--Back to licenses / Add New License-->
            <div v-else class="add-new-license-container">
                <MainLoader class="section-wrap" v-if="loadLicense" />
                <div class="content-wrap section-wrap" v-if="!loadLicense">
                    <div class="back-btn-wrap">
                        <button @click="listing = true" class="primary-btn extra-small">
                            <i class="fa fa-chevron-left"></i><span> {{ $t("businessLicense.backToLicenses") }}</span>
                        </button>
                    </div>
                    <form @submit="addLicense" method="POST">
                        <div class="form-wrapper section-wrap">
                            <div class="input-wrap">
                                <label for="license-number" class="form-label">{{ $t("businessLicense.licenseNumber")
                                }} *</label>
                                <div>
                                    <input placeholder="License Number" type="text" class="text-field"
                                        id="license-number" v-model="license.number" />
                                </div>
                            </div>
                            <div class="input-wrap">
                                <label for="first-name" class="form-label">{{ $t("businessLicense.firstName")
                                }}*</label>
                                <div class="">
                                    <input placeholder="First Name" type="text" required class="text-field"
                                        id="first-name" v-model="license.first_name" />
                                </div>
                            </div>
                            <div class="input-wrap">
                                <label for="last-name" class="form-label">{{ $t("businessLicense.lastName") }}*</label>
                                <div>
                                    <input placeholder="Last Name" type="text" class="text-field" id="last-name"
                                        v-model="license.last_name" />
                                </div>
                            </div>
                            <div class="input-wrap">
                                <label for="country" class="form-label">{{ $t("businessLicense.stateOfIssueCountry")
                                }}*</label>
                                <div>
                                    <input placeholder="State of Issue / Country" type="text" class="text-field"
                                        id="country" v-model="license.country" />
                                </div>
                            </div>
                            <div class="input-wrap">
                                <label for="information" class="form-label">{{ $t("businessLicense.licenseInformation")
                                }}*</label>
                                <div>
                                    <quill-editor v-model:content="license.information" contentType="html"
                                        :editorToolbar="customToolbar" placeholder="Write license information">
                                    </quill-editor>
                                </div>
                            </div>
                            <div class="input-wrap" v-if="canUploadImage()">
                                <label for="information" class="form-label">{{ $t("businessLicense.images") }}</label>
                                <div class="custom-section-wrap" v-if="canUploadImage()">
                                    <div class="">
                                        <div class="license-image-container-wrapper">
                                            <div class="license-image-container">
                                                <div class="license-img-wrap" title="Add Photo"
                                                    v-on:click="openFileBrowserOverlay(null)">
                                                    <img class="license-images add-image"
                                                        src="../../assets/images/image.svg" />
                                                    <span>{{ $t("businessLicense.addPhoto") }}</span>
                                                </div>
                                            </div>
                                            <div class="license-image-container"
                                                v-for="(image, index) in license.images" :key="index"
                                                v-bind:class="{ 'no-padding-bottom': !image.image }">
                                                <!--    <img v-if="image.image"  v-on:click="openFileBrowserOverlay(image.id)" class="license-images pointer" :src="'https://storage.sandbox.ringmystylist.com/images/605c96eb7d0bf_package-1426094.jpg'"> -->
                                                <div class="inner-image">
                                                    <img title="Change Photo" v-if="image.image"
                                                        v-on:click="openFileBrowserOverlay(image.id)"
                                                        class="license-images" :src="domain + image.image" />
                                                </div>

                                                <div v-if="image.image" class="inner-image-action-block"
                                                    v-on:click="onDeleteLicenseImage(image)">
                                                    <i class="pointer fa fa-trash"></i>
                                                    {{ $t("businessLicense.delete") }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="licenseImageUpload.show">
                                <div class="image-upload-overlay"></div>
                                <div class="image-upload-overlay-content">
                                    <div>
                                        <span>Add Photo</span>
                                        <input class="image-input-file" type="file" ref="licenseImageInputFile"
                                            name="img[]" accept="image/*" v-on:change="licenseImageChange($event)" />
                                    </div>
                                    <div class="input-group-license">
                                        <div class="input-browse">
                                            <input type="text" class="text-field" disabled placeholder="Upload File"
                                                v-model="licenseImageUpload.fileName" />
                                        </div>
                                        <div class="inner-input-group-append">
                                            <button v-on:click="openFileBrowser" type="button" class="primary-btn">
                                                {{ $t("businessLicense.browse") }}
                                            </button>
                                        </div>
                                    </div>
                                    <div class="license-image-upload-preview" v-if="licenseImageUpload.preview">
                                        <img :src="licenseImageUpload.preview" class="license-images" />
                                    </div>
                                    <div class="modal-btns">
                                        <button v-on:click="savelicenseImageUpload" type="button" class="primary-btn">
                                            {{ $t("businessLicense.save") }}
                                        </button>
                                        <button v-on:click="cancellicenseImageUpload" type="button"
                                            class="secondary-btn">
                                            {{ $t("businessLicense.cancel") }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="license-btn-wrap">
                        <div class="license-btn" @click="addLicense">
                            <button class="primary-btn extra-small" type="submit">
                                {{ $t("businessLicense.saveLicense") }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <MainLoader class="section-wrap" v-if="firstLoad" />
    </div>
</template>

<script>
import auth from "../../services/auth.js";
import api from "../../services/apiEndpoints.js";
import store from "../../services/vuex.js";
import eventBus from "../../services/eventBus.js";
import { QuillEditor } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import messages from "../../services/messages.js";
import MainLoader from "./general-components/MainLoader.vue"
import imageCompression from "browser-image-compression";


export default {
    name: "AdminBusinessLicense",
    data: function () {
        return {
            listing: true,
            domain: "",
            user: null,
            stylistProfile: {},
            for_stylist_id: 0,
            licenses: [],
            license: {
                id: 0,
                number: "",
                first_name: "",
                last_name: "",
                stylist_id: "",
                country: "",
                information: "",
                images: [],
            },
            licenseImageUpload: {
                show: false,
                index: 0,
                preview: null,
                fileName: null,
                file: null,
            },
            customToolbar: [
                ["bold", "italic", "underline", "strike"],
                [
                    { align: "" },
                    { align: "center" },
                    { align: "right" },
                    { align: "justify" },
                    { list: "ordered" },
                    { list: "bullet" },
                ],
            ],
            firstLoad: false,
            loadLicense: false,
        };
    },
    mounted: function () {
        this.user = auth.state.user;
        this.for_stylist_id = auth.state.user.id;

        //check if adminDetails are either in store or loaded
        //if yes then do necessary logic
        if (this.$store.state.adminDetails.user) {
            this.onAdminDetailsLoad();
        }

        this.getBusinessLicenses();
        let self = this;
        eventBus.on("admin_details_loaded", function () {
            self.onAdminDetailsLoad();
        });
    },
    beforeUnmount() { },
    computed: {
        adminDetails: {
            get: function () {
                return this.$store.state.adminDetails;
            },
            set: function (value) {
                this.$store.commit("setAdminDetails", value);
            },
        },
        groupMembers: {
            get: function () {
                return this.$store.state.stylists;
            },
            set: function (value) {
                this.$store.commit("setStylists", value);
            },
        },
    },
    methods: {
        onAdminDetailsLoad() {
            if (this.adminDetails.group_id && this.adminDetails.group_owner) {
                this.getGroupsMembers(this.adminDetails.group_id);
            }
        },
        getGroupsMembers(group_id) {
            this.$http.get(api.actions.get_stylist_group_members + group_id).then(
                function (response) {
                    if (typeof response.data.members != "undefined") {
                        this.groupMembers = response.data.members;
                    }
                }.bind(this),
                function () {
                    return false;
                }
            );
        },

        getBusinessLicenses() {
            this.firstLoad = true;
            this.$http.get(api.actions.get_business_licenses + "/" + this.for_stylist_id).then(
                function (response) {
                    if (typeof response.data.licenses != "undefined") {
                        this.licenses = response.data.licenses;
                        this.firstLoad = false;
                    }
                }.bind(this)
            );
        },

        onStylistChange() {
            this.listing = true;
            this.getBusinessLicenses();
        },

        openFileBrowser() {
            if (this.$refs.licenseImageInputFile) {
                this.$refs.licenseImageInputFile.click();
            }
        },
        openFileBrowserOverlay(index) {
            this.licenseImageUpload.index = index;
            this.licenseImageUpload.show = true;
        },
       
        async licenseImageChange(e) {
            let file = e.target.files[0];

            if (!file) return;

            try {
                // compression options
                const options = {
                    maxSizeMB: 1,          // adjust (0.5 - 2 MB typical)
                    maxWidthOrHeight: 1920,
                    useWebWorker: true
                };

                // compress image
                const compressedFile = await imageCompression(file, options);

                // store compressed file instead of original
                this.licenseImageUpload.file = compressedFile;
                this.licenseImageUpload.fileName = compressedFile.name;

                // preview
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.licenseImageUpload.preview = e.target.result;
                };
                reader.readAsDataURL(compressedFile);

            } catch (err) {
                console.error("Image compression failed:", err);

                // fallback to original file
                this.licenseImageUpload.file = file;
                this.licenseImageUpload.fileName = file.name;
            }
        },

        cancellicenseImageUpload() {
            this.licenseImageUpload = {
                index: 0,
                show: false,
                fileName: null,
                preview: null,
                file: null,
            };

            if (this.$refs.licenseImageInputFile) {
                this.$refs.licenseImageInputFile.value = null;
            }
        },
        savelicenseImageUpload() {

            if (!this.licenseImageUpload.file) {
                messages.errorMessage("Please select an image");
                return;
            }

            let id = this.license.id;

            if (!id) {
                this.saveLicense(true);
                return;
            }

            this.uploadImageRequest();
        },

        uploadImageRequest() {

            if (!this.licenseImageUpload.file) {
                messages.errorMessage("Please select an image");
                return;
            }

            let formData = new FormData();
            formData.append("image", this.licenseImageUpload.file);
            formData.append("license_id", this.license.id);

            this.$http.post(
                api.actions.save_business_license_image,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }
            ).then(function (response) {
                if (response.data.error) {
                    messages.errorMessage(`${response.data.message}`);

                    return
                }
                if (!response.data.error) {
                    this.editLicense(this.license.id); // refresh images
                    messages.successMessage(messages.GLOBAL_MESSAGES.LICENSE_IMAGE_CHANGED);
                }

            }.bind(this));

            this.cancellicenseImageUpload();
        },

        addLicense() {
            this.saveLicense();
        },



        saveLicense(upload = false) {

            this.license.stylist_id = this.for_stylist_id;

            this.$http.post(api.actions.save_business_license, this.license).then(
                function (response) {
                    if (response.data.error == false) {

                        this.license.id = response.data.license.id;

                        if (upload) {
                            this.uploadImageRequest();
                            return;
                        }

                        this.listing = true;
                        this.getBusinessLicenses();
                        messages.successMessage("The business license has been saved.");
                    }

                }.bind(this),
                function () {
                    return false;
                }
            );
        },
        editLicense(id) {
            if (id) {
                this.loadLicense = true;
            }

            this.listing = false;

            this.$http.get(api.actions.get_business_license + "/" + id)
                .then(function (response) {
                    if (typeof response.data.license !== "undefined") {
                        let license = response.data.license;

                        this.license = {
                            id: license.id,
                            number: license.number,
                            first_name: license.first_name,
                            last_name: license.last_name,
                            country: license.country,
                            information: license.information,
                            images: license.images,
                        };

                        this.domain = response.data.domain;
                    }
                }.bind(this))
                .finally(function () {
                    this.loadLicense = false;
                }.bind(this));
        },

        deleteLicense(id) {
            let customClass = "rms-app";
            document.querySelector("body").classList.add("rms-app");

            if (this.generalOptions.app_id === 2) {
                customClass = "rmb-app";
                document.querySelector("body").classList.add("rmb-app");
            } else if (this.generalOptions.app_id === 5) {
                customClass = "rml-app";
                document.querySelector("body").classList.add("rml-app");
            }

            this.$swal({
                title: this.$t("portfolio.confirmQuestion"),
                icon: "warning",
                showCancelButton: true,
                customClass: customClass,
                confirmButtonText: this.$t("portfolio.confirmYes"),
                cancelButtonText: this.$t("portfolio.confirmNo"),
            }).then((result) => {
                if (result.value) {
                    this.$http.post(api.actions.delete_business_license, { id: id }).then(
                        function (response) {
                            if (response.data.error == false) {
                                this.listing = true;
                                this.getBusinessLicenses();
                                messages.successMessage("The business license has been deleted.");
                            }
                        }.bind(this),
                        function () {
                            return false;
                        }
                    );
                }
            });
        },

        onDeleteLicenseImage(image) {
            let customClass = "rms-app";
            document.querySelector("body").classList.add("rms-app");

            if (this.generalOptions.app_id === 2) {
                customClass = "rmb-app";
                document.querySelector("body").classList.add("rmb-app");
            } else if (this.generalOptions.app_id === 5) {
                customClass = "rml-app";
                document.querySelector("body").classList.add("rml-app");
            }

            this.$swal({
                title: this.$t("portfolio.confirmQuestion"),
                icon: "warning",
                showCancelButton: true,
                customClass: customClass,
                confirmButtonText: this.$t("portfolio.confirmYes"),
                cancelButtonText: this.$t("portfolio.confirmNo"),
            }).then((result) => {
                if (result.value) {
                    this.deleteLicenseImage(image);
                }
            });
        },
        deleteLicenseImage(image) {
            let data = {
                id: image.id,
            };
            this.$http.post(api.actions.delete_license_image, data).then(
                function (response) {
                    if (response.data.error == false) {
                        messages.successMessage(messages.GLOBAL_MESSAGES.PORTFOLIO_IMAGE_DELETED);
                        this.editLicense(this.license.id);
                    }
                }.bind(this),
                function () {
                    return false;
                }
            );
        },
        clearLicense() {
            this.license = {
                id: 0,
                number: "",
                first_name: this.user.first_name,
                last_name: this.user.last_name,
                country: "",
                information: "",
                images: [],
            };
            this.$http.get(api.actions.get_stylist_details + this.user.id).then((res) => {
                this.license.country = res.data.details.profile.city + "/" + res.data.details.profile.state;
            });
            this.listing = false;
        },
        canUploadImage() {
            if (
                this.license.number == "" ||
                this.license.first_name == "" ||
                this.license.last_name == "" ||
                this.license.country == ""
            ) {
                return false;
            }
            return true;
        },
    },
    components: {
        QuillEditor,
        MainLoader,
    },
};
</script>
